import { isDesktopViewport } from "../../utils/responsive";

export const surfaceMap: { [key: string]: string } = {
  Hard: "cemento",
  Grass: "erba",
  Clay: "terra",
};

export function getAdvElement(tag: string) {
  if (isDesktopViewport()) {
    return document.querySelector<HTMLDivElement>('.js-adv-container-top[data-state="not-to-inject"]')
  } else {
    return document.querySelector<HTMLDivElement>(`${tag} [data-state="not-to-inject"]`);
  }
}
